module.exports = __webpack_public_path__ + "static/ms-icon-150x150-6f0e7ce6e85ad2f5025fd13102c30ee9.png";